import { inject, Injectable } from '@angular/core'
import { firstValueFrom } from 'rxjs'
import { SessionService } from 'superlikers-microsites-api'

import { Store, CircuitsStore } from '@core/stores'
import { LocalStorageService } from '@core/services'

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  sessionService = inject(SessionService)
  localStorage = inject(LocalStorageService)
  store = inject(Store)
  circuitStore = inject(CircuitsStore)

  async logout() {
    const response$ = this.sessionService.logout()
    const response = await firstValueFrom(response$)

    this.store.setUser(null)
    this.circuitStore.setCircuits([])
    return response
  }

  async checkRequirements() {
    const response$ = this.sessionService.checkRequirements()
    const response = await firstValueFrom(response$)
    return response
  }
}
